var React = require('react');

function IconProcessSolid (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M710.5 751.1C658.8 800.5 589.1 831 512.2 831s-146.6-30.5-198.3-79.8c-24.6 19.6-55.4 31.9-89.3 31.9-4.2 0-8.1-.9-12.2-1.2 70.3 88.2 178.4 145 299.7 145s229.4-56.8 299.7-145c-4.1.3-8 1.2-12.2 1.2-33.8-.1-64.6-12.3-89.1-32zM224.6 495.5c1.5 0 2.8.4 4.3.4 15.8-94.3 77.5-173.1 161.4-212.6-13.6-22-21.9-47.7-21.9-75.4 0-7 1.1-13.7 2.1-20.5-138 55.2-236.2 188.3-240.8 344.6 25.3-22.4 58.3-36.5 94.9-36.5zM656.2 207.9c0 28.1-8.4 54-22.2 76.1 83.8 39.5 146 117.5 161.8 211.8 1.5 0 2.8-.4 4.3-.4 36.7 0 69.9 14.2 95.3 36.9-4.5-156.5-103.1-289.7-241.1-344.9.8 6.8 1.9 13.5 1.9 20.5z","key":0}),React.createElement("circle",{"cx":"512.2","cy":"199.4","r":"102.2","key":1}),React.createElement("circle",{"cx":"811.9","cy":"644.1","r":"102.2","key":2}),React.createElement("circle",{"cx":"212.7","cy":"644.1","r":"102.2","key":3})]);
}

IconProcessSolid.displayName = "IconProcessSolid";

IconProcessSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconProcessSolid;

IconProcessSolid.default = IconProcessSolid;
